var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTablePiechart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 1,
    fill: "none",
    stroke: "#a805fb",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    width: 26,
    height: 30,
    strokeLinejoin: "miter"
  }), /*#__PURE__*/React.createElement("polyline", {
    "data-cap": "butt",
    "data-color": "color-2",
    fill: "none",
    stroke: "#a805fb",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    points: "16,9 16,16 23,16 ",
    strokeLinejoin: "miter",
    strokeLinecap: "butt"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-color": "color-2",
    fill: "none",
    stroke: "#a805fb",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    cx: 16,
    cy: 16,
    r: 7,
    strokeLinejoin: "miter"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablePiechart);
export default __webpack_public_path__ + "static/media/Table-Piechart.08d1806c4f5ca07a1435d75f89ee6f93.svg";
export { ForwardRef as ReactComponent };